var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c("div", { staticClass: "title-con" }, [
        _c("h1", { staticClass: "case-title" }, [
          _vm._v(_vm._s(_vm.case_info.caseName)),
        ]),
      ]),
      _c("div", { staticClass: "case-open" }, [
        _c(
          "div",
          { staticClass: "animate__animated animate__fadeIn" },
          [
            _vm.case_awards.length && _vm.case_open_number <= 1
              ? _c(
                  "p-case-opening",
                  {
                    ref: "case_opening_box",
                    attrs: {
                      items: _vm.case_awards,
                      isTransition: !_vm.is_jump_case_open_animation_1,
                    },
                    on: {
                      on_finished: function () {
                        return _vm.on_case_opened()
                      },
                    },
                  },
                  [
                    !_vm.isRunning
                      ? _c("div", { staticClass: "case-con" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "case-img-con animate__animated animate__tada animate__slower",
                            },
                            [
                              _vm.case_info.casePic
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "case-img animate__animated animate__pulse animate__infinite animate__slower animate__delay-2s",
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: _vm._f("imgfilter")(
                                            _vm.case_info.casePic
                                          ),
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm.case_awards.length && _vm.case_open_number > 1
              ? _c(
                  "p-case-opening-more",
                  {
                    ref: "case_opening_box_more",
                    attrs: {
                      items: _vm.case_awards,
                      lotteryCount: _vm.case_open_number,
                      isTransition: !_vm.is_jump_case_open_animation_1,
                    },
                    on: {
                      on_finished: function () {
                        return _vm.on_case_opened()
                      },
                    },
                  },
                  [
                    !_vm.isRunning
                      ? _c("div", { staticClass: "case-con" }, [
                          _c("div", { staticClass: "case-img-con" }, [
                            _vm.case_info.casePic
                              ? _c("div", { staticClass: "case-img" }, [
                                  _c("img", {
                                    attrs: {
                                      src: _vm._f("imgfilter")(
                                        _vm.case_info.casePic
                                      ),
                                    },
                                  }),
                                ])
                              : _vm._e(),
                          ]),
                        ])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "ctrl-con" },
          [
            _c(
              "el-row",
              [
                _c(
                  "el-col",
                  {
                    staticClass: "col-left-item",
                    attrs: { xs: 24, sm: 24, md: 10, lg: 10 },
                  },
                  [
                    _vm.case_open_number > 1
                      ? _c("div", { staticClass: "open-count-con" }, [
                          _c(
                            "div",
                            { staticClass: "open-count" },
                            [
                              _c("p", { staticClass: "title" }, [
                                _vm._v("开箱数量:"),
                              ]),
                              _vm._l(
                                Array.from(Array(5).keys()).map(function (num) {
                                  return num + 1
                                }),
                                function (number) {
                                  return _c(
                                    "div",
                                    {
                                      key:
                                        number +
                                        "_" +
                                        (number === _vm.case_open_number),
                                      staticClass: "open-count-item",
                                      class: {
                                        active: number === _vm.case_open_number,
                                      },
                                      on: {
                                        click: function () {
                                          if (!_vm.isRunning) {
                                            _vm.case_open_number = number
                                          }
                                        },
                                      },
                                    },
                                    [_vm._v(" x" + _vm._s(number) + " ")]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                        ])
                      : _c("div", {
                          staticStyle: { width: "10px", height: "10px" },
                        }),
                  ]
                ),
                _c(
                  "el-col",
                  {
                    staticClass: "flex flex-center-1",
                    attrs: { xs: 24, sm: 24, md: 5, lg: 4 },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "animate__animated animate__rubberBand animate__slower",
                      },
                      [
                        _vm.case_info.useType != 3 && _vm.case_open_number > 1
                          ? _c(
                              "button",
                              {
                                staticClass: "open-case-btn",
                                on: {
                                  click: function () {
                                    return _vm.case_open("normal")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " 打开 " +
                                    _vm._s(_vm.case_open_number) +
                                    "次   "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.case_info.useType != 3 && _vm.case_open_number == 1
                          ? _c(
                              "button",
                              {
                                staticClass: "open-case-btn",
                                on: {
                                  click: function () {
                                    return _vm.case_open("normal")
                                  },
                                },
                              },
                              [_vm._v(" 打开 ")]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]
                ),
                _c(
                  "el-col",
                  {
                    staticClass: "flex flex-ver flex-wrap col-right",
                    attrs: { xs: 24, sm: 24, md: 9, lg: 10 },
                  },
                  [
                    _c("div", { staticClass: "jump-animate-con" }, [
                      _c(
                        "div",
                        { staticClass: "jump-animate" },
                        [
                          _c("i-switch", {
                            attrs: {
                              "false-color": "#14131d",
                              "true-color": "#827dff",
                            },
                            on: {
                              "on-change":
                                _vm.toggle_is_jump_case_open_animation_1,
                            },
                            model: {
                              value: _vm.is_jump_case_open_animation_1,
                              callback: function ($$v) {
                                _vm.is_jump_case_open_animation_1 = $$v
                              },
                              expression: "is_jump_case_open_animation_1",
                            },
                          }),
                          _c("span", { staticClass: "text" }, [_vm._v("动画")]),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm.case_info.isShowHistory && !_vm.isGameInstanceCase
        ? _c("div", { staticClass: "recent-drop-con" }, [
            _c("h2", { staticClass: "title" }, [_vm._v("最近掉落")]),
            _c(
              "div",
              { staticClass: "recent-drop" },
              _vm._l(_vm.drop_awards, function (item, award_index) {
                return _c(
                  "div",
                  { key: award_index, staticClass: "item" },
                  [
                    _c("c-award", {
                      staticClass: "award",
                      attrs: {
                        rarity: item.rarity,
                        picture: item.itempic,
                        name: item.itemname,
                        price: item.price,
                        width: "100%",
                      },
                    }),
                  ],
                  1
                )
              }),
              0
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "case-award animate__animated animate__fadeInUp" },
        [
          !_vm.isGameInstanceCase
            ? _c("div", { staticClass: "case-award-title" }, [
                _c("div", { staticClass: "text" }, [
                  _vm._v("此箱子包含以下物品"),
                ]),
                _c("div", { staticClass: "probability" }, [
                  _c(
                    "div",
                    {
                      staticClass: "ruler-text",
                      on: {
                        click: function ($event) {
                          _vm.notice_modal_show = true
                        },
                      },
                    },
                    [
                      _c("span", [_vm._v("概率说明")]),
                      _c("img", {
                        attrs: {
                          src: require("../../../assets/images/help_fill.png"),
                          alt: "",
                        },
                      }),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.isGameInstanceCase
            ? _c("div", { staticClass: "case-award-title-1" }, [
                _c("div", { staticClass: "text" }, [
                  _vm._v("此箱子包含以下物品"),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "case-award-list-1" }, [
            _c(
              "div",
              { staticClass: "case-award-list-1-item" },
              _vm._l(_vm.case_awards, function (item, award_index) {
                return _c(
                  "div",
                  { key: award_index, staticClass: "item" },
                  [
                    _c("c-award", {
                      staticClass: "award",
                      attrs: {
                        rarity: item.rarity,
                        picture: item.itempic,
                        name: item.itemname,
                        price: item.price,
                        rate: item.viewRate,
                        width: "100%",
                      },
                    }),
                  ],
                  1
                )
              }),
              0
            ),
          ]),
        ]
      ),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal",
            "footer-hide": "",
            closable: false,
            width: "'400rem'",
          },
          model: {
            value: _vm.is_case_open_cdk_modal_show,
            callback: function ($$v) {
              _vm.is_case_open_cdk_modal_show = $$v
            },
            expression: "is_case_open_cdk_modal_show",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              attrs: { title: _vm.case_info.caseName, has_close_button: "" },
              on: { close_button_click: _vm.toggle_case_open_cdk_modal_show },
            },
            [
              _c("div", { staticClass: "case-open-cdk app-form" }, [
                _c("p", { staticClass: "case-open-cdk__desc" }, [
                  _vm._v("请输入您的CD-KEY，以开启箱子"),
                ]),
                _c("label", { staticClass: "app-form__field" }, [
                  _c("div", { staticClass: "app-form__field_icon_input" }, [
                    _c("i", { staticClass: "ivu-icon ivu-icon-md-key" }),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.case_open_cdk,
                          expression: "case_open_cdk",
                        },
                      ],
                      staticClass: "app-form__field__input pad50",
                      attrs: {
                        type: "text",
                        autocomplete: "off",
                        placeholder: "请输入您的CD-KEY",
                      },
                      domProps: { value: _vm.case_open_cdk },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.case_open_cdk = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
              _c(
                "div",
                {
                  staticClass: "submit-button",
                  staticStyle: { width: "100%" },
                  on: {
                    click: function ($event) {
                      return _vm.case_open("cdk")
                    },
                  },
                },
                [_vm._v(" 确认开箱 ")]
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal notice-modal",
            "footer-hide": "",
            width: "'438rem'",
            closable: false,
          },
          model: {
            value: _vm.notice_modal_show,
            callback: function ($$v) {
              _vm.notice_modal_show = $$v
            },
            expression: "notice_modal_show",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              attrs: { title: "开箱概率说明", has_close_button: "" },
              on: {
                close_button_click: function () {
                  _vm.notice_modal_show = false
                },
              },
            },
            [
              _c("div", { staticClass: "text-content" }, [
                _c("p", [
                  _vm._v(" 每次开启盲盒为新的一轮"),
                  _c("span", [_vm._v("独立计算")]),
                  _vm._v(" ，多次开启盲盒并"),
                  _c("span", [_vm._v("不意味")]),
                  _vm._v("着某区间"),
                  _c("span", [_vm._v("概率累加")]),
                  _vm._v(" 。 "),
                ]),
                _c("br"),
                _c("br"),
                _c("p", [_vm._v("举例1：")]),
                _c("p", [
                  _vm._v(" 盲盒内有A、B两件饰品,获得概率都为"),
                  _c("span", [_vm._v("50%")]),
                  _vm._v(",当连续开启该盲盒时, "),
                  _c("span", [_vm._v("无法保证")]),
                  _vm._v("开启结果"),
                  _c("span", [_vm._v("稳定")]),
                  _vm._v("为ABABAB "),
                ]),
                _c("br"),
                _c("br"),
                _c("p", [_vm._v("举例2：")]),
                _c("p", [
                  _vm._v(" 某饰品掉率为"),
                  _c("span", [_vm._v("10%")]),
                  _vm._v(", 当连续开启该盲盒时, "),
                  _c("span", [_vm._v("可能10次无掉落")]),
                  _vm._v("该饰品, 也可能20次掉落1次, "),
                  _c("span", [_vm._v("无法保证")]),
                  _vm._v("每开10次"),
                  _c("span", [_vm._v("必定掉落")]),
                  _vm._v("1次该饰品 "),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }